export default __webpack_public_path__ + "locales/lo-LA/Translations.json?hash=53c3b2e9a55b20bef3798e88b5f00e74";